<script setup lang="ts">
import { computed, onMounted } from 'vue';
import ReloadIcon from '@/assets/icons/shared/viewer/reload.svg';
import CloseButton from '@/modules/ui/components/buttons/CloseButton.vue';
import { useVersionStore } from '@/modules/core/stores/version.store.ts';
import AppLogo from '@/modules/core/components/AppLogo.vue';
import { AppUtil } from '@/modules/core/utils/app.util.ts';
import UiButton from '@/modules/ui/components/ui/UiButton.vue';
import UiModal from '@/modules/ui/components/ui/UiModal.vue';

const versionStore = useVersionStore();

const isOpen = computed({
  get: () => versionStore.showModal,
  set: (isOpen) => versionStore.setShowModal(isOpen),
});

const current = computed(() => versionStore.current!.version);
const next = computed(() => versionStore.next!.version);

onMounted(() => versionStore.watch());

function update() {
  AppUtil.clear(false);
  window.location.reload();
}
</script>

<template>
  <UiModal
    v-model="isOpen"
    priority
    popup
  >
    <template #header>
      <div class="header">
        <AppLogo />
        <h2>{{ $t('core.modal.system.update.title') }}</h2>
      </div>
    </template>

    <template #body>
      <i18n-t
        keypath="core.modal.system.update.updateAvailable"
        scope="global"
        tag="p"
      >
        <template #br>
          <br />
        </template>
        <template #current>
          {{ current }}
        </template>
        <template #next>
          {{ next }}
        </template>
      </i18n-t>
      <p class="paragraph">{{ $t('core.modal.system.update.usingNewFeatures') }}</p>
    </template>

    <template #footer>
      <CloseButton @click="isOpen = false" />

      <UiButton @click="update">
        <ReloadIcon v-prefix />
        <span>{{ $t('core.common.button.update') }}</span>
      </UiButton>
    </template>
  </UiModal>
</template>

<style scoped lang="scss">
.header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.app-logo {
  margin-bottom: 8px;
  width: 80px;
  height: 80px;
}

.paragraph {
  &:not(:last-child) {
    margin-bottom: 16px;
  }
}

.ui-button {
  &:not(:last-child) {
    margin-right: 8px;
  }
}
</style>
